// @flow
import type { FSA } from 'types/redux';
import type { CohortPassenger, CohortDriver, CohortMerchant } from 'types/entities';

export const LIBRARY_PASSENGER_ADD: string = 'LIBRARY_PASSENGER_ADD';
export function libraryPassengerAdd(cohortPassenger: CohortPassenger): FSA {
  return {
    type: LIBRARY_PASSENGER_ADD,
    payload: cohortPassenger,
  };
}

export const LIBRARY_PASSENGER_DELETE: string = 'LIBRARY_PASSENGER_DELETE';
export function libraryPassengerDelete(cohortPassengerID: string): FSA {
  return {
    type: LIBRARY_PASSENGER_DELETE,
    payload: {
      cohortPassengerID,
    },
  };
}

export const LIBRARY_DRIVER_ADD: string = 'LIBRARY_DRIVER_ADD';
export function libraryDriverAdd(cohortDriver: CohortDriver): FSA {
  return {
    type: LIBRARY_DRIVER_ADD,
    payload: cohortDriver,
  };
}

export const LIBRARY_DRIVER_DELETE: string = 'LIBRARY_DRIVER_DELETE';
export function libraryDriverDelete(cohortDriverID: string): FSA {
  return {
    type: LIBRARY_DRIVER_DELETE,
    payload: {
      cohortDriverID,
    },
  };
}

export const LIBRARY_MERCHANT_ADD: string = 'LIBRARY_MERCHANT_ADD';
export function libraryMerchantAdd(cohortMerchant: CohortMerchant): FSA {
  return {
    type: LIBRARY_MERCHANT_ADD,
    payload: cohortMerchant,
  };
}

export const LIBRARY_MERCHANT_DELETE: string = 'LIBRARY_MERCHANT_DELETE';
export function libraryMerchantDelete(cohortMerchantID: string): FSA {
  return {
    type: LIBRARY_MERCHANT_DELETE,
    payload: {
      cohortMerchantID,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/library.js
 **/